<template>

    <div>
        <McpWheelLoader 
            :display="displayLoader"
        />

        <article v-if="!displayLoader" class="SavingRecommendationResult">     
            
            <div class="image-container">
                <img :src="recommendationDatas.product_img" :alt="recommendationDatas.product_name">
            </div>
            
            
            <div class="product-recommendation">
                
                <!-- title -->
                <div class="product-recommendation__title">
                    <div>
                        <div class="product-type">{{ recommendationDatas.product_type }}</div>
                        <div v-if="recommendationDatas.real_recommended_product" class="product-name">{{ recommendationDatas.product_name }}</div>
                        <div v-else class="product-name">à partir de</div>
                    </div>

                    <div>
                        <div class="product-price">
                            <p>{{ addThousandSeparationToNumber(Math.floor(recommendationDatas.product_price)) }}€</p>
                            <p class="aids_conditions">
                                <span v-if="hadAids">avant </span> 
                                <span v-else>sans </span> 
                                aides
                            </p>
                        </div>
                        
                    </div>
                </div>

                <!-- description -->
                <p class="product-recommendation__description" :inner-html.prop="recommendationDatas.product_desc"></p>
                
                <!-- price -->
                <div class="product-recommendation__prices">
                    <ul 
                        class="highlighting"
                        :class="{aidsAmount: hadAids}"
                    >
                        <li v-if="hadAids" ><span>Aides *</span> <span>{{ addThousandSeparationToNumber(recommendationDatas.government_aids.totalAids) }}€</span></li>
                        <li v-if="hadAids" ><span>Reste à charge</span> <span>{{ addThousandSeparationToNumber(recommendationDatas.to_pay) }}€</span></li>
                        <li v-if="!hadAids" ><span>Prix</span> <span>{{ addThousandSeparationToNumber( Math.floor(recommendationDatas.product_price)) }}€</span></li>
                    </ul>

                    <ul>
                        <li 
                            v-if="recommendationDatas.financing_price" 
                        >
                            <span>Prix financé <span>sur 60 mois**</span></span> 
                            <span>{{ addThousandSeparationToNumber(recommendationDatas.financing_price) }}€ <span class="month">/mois</span></span>
                        </li>

                        <li 
                            :class="{full_width: !recommendationDatas.financing_price}"
                        >
                            <span>Économies d’énergies</span> <span :class="{negative: (recommendationDatas.potential_saving && recommendationDatas.potential_saving.toString().includes('+') ? 'negative' : '')}">{{ (recommendationDatas.potential_saving && recommendationDatas.potential_saving.toString().includes('+') ? '+': '') }} {{ Math.round(recommendationDatas.potential_saving/12) }}€ <span class="month">/mois</span></span>
                        </li>

                        <li
                            v-if="recommendationDatas.financing_price" 
                        >
                            <span>{{ monthlyAmount.label }}</span> 
                            <span>{{ monthlyAmount.value }}€</span>
                        </li>
                    </ul>
                </div>

            </div>

        </article>
    
        <!-- Aids Infos -->
        <DropdownInfos
            v-if="hadAids"
            :headText="aidsInfosText"
        />

        <DropdownInfos
            v-if="recommendationDatas.financing_price"
            :headText="financingInfosText.head"
            :contentText="financingInfosText.content"
        />
    </div>
</template>

<script>
import DropdownInfos from '@/components/DropdownInfos/DropdownInfos.vue';
import McpWheelLoader from '@/components/Loaders/McpWheelLoader.vue';

import { addThousandSeparationToNumber } from "@/services/tools.js";
import { mapActions } from "vuex";

export default {
    name: "SavingRecommendationResult",

    data() {
        return {
            displayLoader: true,
            recommendationDatas: {},
            hadAids: false,
            monthlyAmount: {},
            aidsInfosText: '',
            financingInfosText: {
                head: null,
                content: null
            },
            formatedPrice: 0,
        };
    },
    
    components: { 
        DropdownInfos,
        McpWheelLoader
    },

    methods: {
  
        async submitLead() {
            try {
                //UpdateLead
                const response = await this.doSaveLead({step: `?step_number=3&last_action=Rdv`, saveLead: true})
                
                this.recommendationDatas = response.data;
                this.setRecomandationDatas(this.recommendationDatas);
                this.displayLoader = false;

            } catch(error) {
                console.error(error)
                this.displayLoader = false;
                
                this.$fire({
                    title: "Oups",
                    text: "Une erreur est survenu lors de l'ajout au panier",
                    type: "error",
                    timer: 1500,
                    position: "top-end",
                });
            }
            
        },

        /**
         * @param {Object} recommendationDatas - response from doSaveLead call
         */
        setRecomandationDatas(recommendationDatas) {
            this.hadAids = recommendationDatas.government_aids.totalAids > 0;
    
            /* Prime Info Text */
            let primeCEEText = `* Aides décomposées en ${ this.recommendationDatas.government_aids.primeCEE } € de Prime CEE 
                                    'Coup de Pouce' directement déduit de votre devis`;
            let primeRenovText = `et ${ this.recommendationDatas.government_aids.primeRenov } € 
                                    de MaPrimeRénov versé par l'Etat.`;
                                    this.recommendationDatas.government_aids.primeRenov = 10;
            this.aidsInfosText = this.recommendationDatas.government_aids.primeRenov > 0 ? primeCEEText.concat(' ', primeRenovText) : primeCEEText,
            
            this.setMonthlyAmount(this.recommendationDatas.financing_price ,Math.round(this.recommendationDatas.potential_saving/12));

            this.financingInfosText = {
                head: `** Financement ${recommendationDatas.product_type}`,
                content:recommendationDatas.product_financing_infos, 
            }
        },

        /**
         * Real saving or remains to pay per month
         * @param {Number} financingAmount
         * @param {Number} savingAmount
         */
        setMonthlyAmount(financingAmount, savingAmount) {
            if(financingAmount - savingAmount >= 0) {
                this.monthlyAmount = {
                    label: 'Reste à charge mensuel',
                    value: financingAmount - savingAmount
                }
            } else {
                this.monthlyAmount = {
                    label: 'Économies mensuelles',
                    value:   savingAmount - financingAmount
                }
            }
        },

        ...mapActions([
            "setAnswerDatas",
            "doSaveLead"
        ]),

        //Imported functions
        addThousandSeparationToNumber
    },

    mounted() {
        this.submitLead();
    },
    
}
</script>

<style lang="scss">
.SavingRecommendationResult {

    @include breakpoint(only-md) {
        padding-bottom: 100px;
    }

    // img
    .image-container {
        text-align: center;
        box-shadow: 0px 25px 40px 0px #0c232c1a;
        border-radius: 10px;

        @include breakpoint(only-lg) {
            margin: 35px 0;
        }

        img {
            max-width: 160px;
        }
    }

    //product info
    .product-recommendation {
        &__title  {
            .product-type {
                font-size: 2.4rem;
                color: $c-mcp-red;
                font-weight: $fw-robotoM;
            }

            .product-name {
                font-size: 3rem;
                font-weight: $fw-robotoM;
            }

            .product-price {
                font-size: 3rem;
                color: $c-grey-3;
                display: flex;
                align-items: flex-end;
                flex-wrap: wrap;
                gap: 15px;

                p {
                   line-height: 1; 
                }

                .aids_conditions {
                    font-size: 1.4rem;
                    color: $c-grey-light;
                }
            }
        }

        &__description {
            margin: 10px 0;
            color: $c-grey-blue;
            font-size: 1.6rem;
        }

        &__prices {
            ul {
                display: flex;

                @include breakpoint(only-sm) {
                    flex-wrap: wrap;
                }

                @include breakpoint(only-lg) {
                    gap: 20px;
                }

                li {
                    padding: 20px;

                    @include breakpoint(only-lg) {
                        width: calc(50% - 10px);
                        text-align: center;
                        border-radius: 10px;
                        border: 1px solid $c-grey-5;
                        
                        &.full_width {
                            width: 100%;
                        }
                    }

                    >span {
                        display: block;
                        line-height: 1;

                        &:first-child {
                            font-size: 1.4rem;
                            margin-bottom: 10px;

                            span {
                                font-size: 1rem;
                            }
                        }

                        &:last-child {
                            font-size: 2.1rem;
                            color: $c-mcp-green;
                            white-space: nowrap;

                            span.month{
                                font-size: 1rem;
                            }
                        }
                    }

                    >span.negative {
                        color: $c-mcp-red;
                    }
                }

                &.highlighting {                    
                    @include breakpoint(only-lg) {
                        margin: 20px 0;
                    }
                    
                    li {
                        color: $color-white;
                        background-color: $c-mcp-green;
                        border-color: $c-mcp-green;

                        span:last-child {
                            color: $color-white;
                        }
                    }

                    &:not(.aidsAmount) {
                        li {
                            width: 100%;
                        }
                    }
                }
            }
        }
    }
}

// Responsive
.SavingRecommendationResult {

    // Screen min 769px
    @include breakpoint(md) {
        margin-bottom: 100px;
    }
    
    // Screen min 1024px
    @include breakpoint(lg) {
        display: flex;
        gap: 5vw;
        padding: 30px 3vw;
        border-radius: 10px;
        box-shadow: 0px 25px 40px 0px #0C232C1A;

        .image-container {
            background-color: $color-white;
            transform: translateY(20%);

            img {
               max-width: 370px;
            }        
        }

        //Right 
        .product-recommendation {
                display: flex;
                justify-content: center;
                flex-direction: column;
            
            &__title {
                display: flex;
                align-items: flex-end;
                gap: 20px;
            }

            &__description {
                margin: 30px 0;
            }

            &__prices {
                display: flex;
                width: fit-content;
                border: 1px solid $c-grey-5;
                border-radius: 10px;
                overflow: hidden;

                ul li {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                }

                ul.highlighting {
                    overflow: visible;
                    border-radius: 10px;

                    li:last-child {
                        border-top-right-radius: 10px;
                        border-bottom-right-radius: 10px;
                    }
                }
                
            }
        }
    }
}
</style>